var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            direction: _vm.direction,
            modal: true,
            visible: _vm.drawer,
            "with-header": false,
            "wrapper-closable": true,
            wrapperClosable: false,
            size: "700px",
            title: "组织架构",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "table-box" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.activeName = 0
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("setting.edit.editorialmembers")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              false
                ? _c(
                    "span",
                    {
                      class: { on: _vm.activeName == 1 },
                      on: {
                        click: function ($event) {
                          _vm.activeName = 1
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("setting.edit.permissionsetting")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName == 0,
                    expression: "activeName == 0",
                  },
                ],
              },
              [
                _vm.userInfo
                  ? _c(
                      "div",
                      { staticClass: "form-box ml20" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "ruleForm",
                            staticClass: "demo-ruleForm",
                            attrs: {
                              model: _vm.userInfo,
                              rules: _vm.rules,
                              "label-width": "auto",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("setting.edit.membername") + "：",
                                  prop: "name",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { clearable: "", size: "small" },
                                  model: {
                                    value: _vm.userInfo.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userInfo, "name", $$v)
                                    },
                                    expression: "userInfo.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("setting.edit.phone") + "：",
                                  prop: "phone",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { clearable: "", size: "small" },
                                  model: {
                                    value: _vm.userInfo.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userInfo, "phone", $$v)
                                    },
                                    expression: "userInfo.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "部门：", prop: "name" } },
                              [
                                _c("select-department", {
                                  ref: "selectDepartment",
                                  attrs: {
                                    "is-site": true,
                                    value: _vm.frames || [],
                                  },
                                  on: { changeMastart: _vm.changeMastart },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "custom",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "item-box" },
                                              [
                                                _vm._l(
                                                  _vm.frames,
                                                  function (item, index) {
                                                    return _c(
                                                      "el-popover",
                                                      {
                                                        key: index,
                                                        ref: "popover-" + index,
                                                        refInFor: true,
                                                        staticClass: "item",
                                                        attrs: {
                                                          width: 80,
                                                          placement:
                                                            "bottom-end",
                                                          trigger: "click",
                                                        },
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "prop-txt",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleDepartment(
                                                                      item,
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "setting.edit.setdepartment"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "prop-txt",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleDeleteDep(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "public.delete"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              slot: "reference",
                                                              size: "small",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  item.name
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                            item.is_mastart
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#1890ff",
                                                                        "font-size":
                                                                          "12px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " (主) "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-right el-icon--right",
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      size: "small",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: _vm.handleOpen,
                                                    },
                                                  },
                                                  [_vm._v(" 修改 ")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2061522697
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("setting.edit.position") + "：",
                                  prop: "position",
                                },
                              },
                              [
                                _c("el-cascader", {
                                  attrs: {
                                    options: _vm.treeData,
                                    props: _vm.propsPos,
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.userInfo.position,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userInfo, "position", $$v)
                                    },
                                    expression: "userInfo.position",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "部门负责人：", prop: "name" },
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.userInfo.is_admin,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.userInfo,
                                              "is_admin",
                                              $$v
                                            )
                                          },
                                          expression: "userInfo.is_admin",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("customer.no"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("customer.yes"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.userInfo.is_admin
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "负责部门：",
                                      prop: "manage_frame",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          multiple: "",
                                          placeholder: "请选择",
                                          size: "small",
                                        },
                                        model: {
                                          value: _vm.userInfo.manage_frame,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.userInfo,
                                              "manage_frame",
                                              $$v
                                            )
                                          },
                                          expression: "userInfo.manage_frame",
                                        },
                                      },
                                      _vm._l(_vm.frames, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("setting.edit.directsuperior") +
                                    "：",
                                  prop: "name",
                                },
                              },
                              [
                                _c("select-member", {
                                  ref: "selectMember",
                                  attrs: {
                                    "only-one": true,
                                    value: _vm.superiorUser || [],
                                  },
                                  on: { getSelectList: _vm.getSelectList },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "custom",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _vm.superiorUser.length > 0
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm
                                                                .superiorUser[0]
                                                                .name
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.handlesuperiorOpen,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.superiorUser
                                                            .length > 0
                                                            ? _vm.$t(
                                                                "public.modify"
                                                              )
                                                            : _vm.$t(
                                                                "public.add"
                                                              )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3606897522
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("public.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }